import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=78eda805&scoped=true&lang=css"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78eda805"]])

export default __exports__